import Wrapper from "../../layout/wrapper/Wrapper";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../styles/pages/submit.module.scss";
import styles1 from "../../styles/pages/release-dashboard.module.scss";
import "react-perfect-scrollbar/dist/css/styles.css";
// import SubmittedDeleteTable from "../../components/AllTable/SubmittedPageVideos/SubmittedDeleteTable";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useQuery } from "react-query";
import { FetchSubmitedVideos } from "../../api/functions/submited.videos.api";
import {
  setReleaseCompany,
  setReleaseStatus,
} from "../../redux-toolkit/slices/released.video.slice";
import ApiLoader from "../../components/Loaders/ApiLoader";
import ReleaseTableTwo from "../../components/ReleasePageTable/ReleaseTableTwo";

function Releasevideo() {
  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const [page, setPage] = useState(1);
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const dispatch = useAppDispatch();

  const { from, to, release_status, release_company } = useAppSelector(
    (s) => s.releasedVideoSlice
  );

  const {
    error,
    data,
    isLoading,
    isRefetching,
    refetch: refetchAgain,
  } = useQuery(["released"], async () =>
    FetchSubmitedVideos({
      published: 2,
      page,
      release_status,
      release_company: release_company.join(","),
      from,
      to,
    })
  );

  const handlePageChange = (p) => {
    setPage(p);
    handleTriggreFetch();
  };

  useEffect(() => {
    refetchAgain();
  }, [fetchTrigger]);

  const filterRefetch = () => {
    refetchAgain();
    setOpenFilterModal(false);
  };

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  const filtersReset = () => {
    setPage(1);
    dispatch(setReleaseStatus(null));
    dispatch(setReleaseCompany([]));
    setOpenFilterModal(false);
    handleTriggreFetch();
  };
  // console.warn('data', data)

  const [filterActive, setFilterActive] = useState(false);

  useEffect(() => {
    if (release_status || release_company.length > 0) {
      setFilterActive(true);
    } else {
      setFilterActive(false);
    }
  }, [release_status, release_company]);

  return (
    <Wrapper>
      <ApiLoader loading={isLoading} />
      <Box className="main_body">
        <Box className={styles.submitPageWrapper}>
          <Box className={styles1.submitTable}>
            <ReleaseTableTwo
              datas={data?.data}
              handlePageChange={handlePageChange}
              filterRefetch={filterRefetch}
              handleClearFilterModal={filtersReset}
              filtersReset={filtersReset}
              filterActive={filterActive}
              error={error}
              page={page}
              handleTriggreFetch={handleTriggreFetch}
              loading={isLoading}
              p={{
                openFilterModal,
                setOpenFilterModal,
                handleTriggreFetch,
              }}
            />
          </Box>
        </Box>
      </Box>
    </Wrapper>
  );
}

export default Releasevideo;
